module.exports = __webpack_public_path__ + "img/bnb.a5c9e94c.svg";